import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { resolveSiteFlowPromptsForConditionType } from '../../domain/condition_families/siteFlowConditionFamily';

type SiteFlowReviewPromptsPanelProps = {
  conditionTypeId: string;
  title?: string;
};

export const SiteFlowReviewPromptsPanel: React.FC<SiteFlowReviewPromptsPanelProps> = ({
  conditionTypeId,
  title = 'Review prompts (static)',
}) => {
  const { prompts, usedFallback } = useMemo(
    () => resolveSiteFlowPromptsForConditionType(conditionTypeId),
    [conditionTypeId],
  );

  if (!prompts.length) return null;

  return (
    <Box data-testid="site-flow-review-prompts-panel">
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Use these questions to guide review. They do not imply automated diagnosis.
      </Typography>
      {usedFallback ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1 }}
          data-testid="site-flow-review-prompts-fallback-note"
        >
          Showing the generic site-flow prompt set because this condition type does not have a dedicated prompt list yet.
        </Typography>
      ) : null}
      <Box component="ul" sx={{ m: 0, pl: 2.25 }}>
        {prompts.map((prompt) => (
          <Typography key={prompt} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {prompt}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default SiteFlowReviewPromptsPanel;
